'use strict'

import { MallApiModel, MallResponse, ResponseConvert } from "./MallApi"

const mallFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;
  resource = resource as URL
  /** 请求拦截开始 */
  /** 请求拦截结束 */
  const response: any = await mallFetch(resource, config);
  let _response = response
  if (response.headers.get("Content-Type")?.indexOf('image/') <= -1) {
    _response = await response.json()
  } else {
    _response = await response.blob()
  }
  /** 请求拦截开始 */
  /** 请求拦截结束 */
  return _response;
};



export const fecthApi: MallApiModel = {
  Get<T>(url: string, data: any, cacheData: boolean = false, customCache?: (data: any, oldData: any, params: any) => any, headers?: any): Promise<MallResponse<T>> {
    return new Promise((resolve, reject) => {
      const _window: any = window;
      const _headers = {
        ...(headers || {}),
        ..._window?.__df_channel_sdk?.getRequestHeader(),
      }
      window.fetch(url, { headers: _headers, method: 'get' }).then((res: any) => {
        const _res = ResponseConvert<T>(res, url, cacheData, data, customCache)
        if (_res.Status === 0) {
          resolve(_res)
        } else {
          console.warn('接口异常：', url, res)
          resolve(_res)
        }
      })
    })
  },
  Post<T>(url: string, data: any, cacheData: boolean = false, customCache?: (data: any, oldData: any, params: any,) => any, headers?: any): Promise<MallResponse<T>> {
    return new Promise((resolve, reject) => {
      const _window: any = window;
      const _headers = {
        'Content-Type': 'application/json',
        ...(headers || {}),
        ..._window?.__df_channel_sdk?.getRequestHeader(),
      }
      window.fetch(url, { body: JSON.stringify(data), headers: _headers, method: 'post' }).then((res: any) => {
        const _res = ResponseConvert<T>(res, url, cacheData, data, customCache)
        if (_res.Status === 0) {
          resolve(_res)
        } else {
          console.warn('接口异常：', url, res)
          resolve(_res)
        }
      })
    })
  },
}